import React, { useContext, useEffect, useMemo } from 'react'

import { legalAgreementIds } from '../../../../utils/legalAgreements'
import BAAContent from '../../../global/agreements/documents/BAAContent'
import PLAgreementContent from '../../../global/agreements/documents/PLAgreementContent'
import PLAgreementContentActions from '../../../global/agreements/documents/PLAgreementContentActions'
import PLAgreementOct022023Content from '../../../global/agreements/documents/previous/PLAgreementOct022023Content'
import PLAgreementOct022023ContentActions from '../../../global/agreements/documents/previous/PLAgreementOct022023ContentActions'
import RxDFHendUSAug2021Content from '../../../global/agreements/documents/previous/RxDFHendUSAug2021Content'
import RxDFHendUSAug2021ContentActions from '../../../global/agreements/documents/previous/RxDFHendUSAug2021ContentActions'
import RxDFHendUSMay2021Content from '../../../global/agreements/documents/previous/RxDFHendUSMay2021Content'
import RxDFHendUSMay2021ContentActions from '../../../global/agreements/documents/previous/RxDFHendUSMay2021ContentActions'
import RxDFHendCAContent from '../../../global/agreements/documents/RxDFHendCAContent'
import { RxDFHendCAContentActions } from '../../../global/agreements/documents/RxDFHendCAContentActions'
import RxDFHendUSContent from '../../../global/agreements/documents/RxDFHendUSContent'
import RxDFHendUSContentActions from '../../../global/agreements/documents/RxDFHendUSContentActions'
import ClickWrapContextProvider from '../../../global/clickwrap/ClickWrapContextProvider'
import ClickWrapModal from '../../../global/clickwrap/ClickWrapModal'
import { ClickWrapModalContent } from '../../../global/clickwrap/ClickWrapModalContent'
import { ClickWrapModalContext } from '../../../global/clickwrap/context'
import withAcceptedContentActions from './withAcceptedContentActions'

export interface ViewAcceptedAgreementProps {
  agreementId?: string
}

const ViewAcceptedAgreement: React.FC<ViewAcceptedAgreementProps> = ({ agreementId }) => {
  const [, modalDispatch] = useContext(ClickWrapModalContext)

  const { Content, AdditionalActions } = useMemo(() => {
    const defaultResponse = { Content: null, AdditionalActions: null }
    if (!agreementId) {
      return defaultResponse
    }
    switch (agreementId) {
      case legalAgreementIds.rxDFHendCASept2021:
        return {
          Content: RxDFHendCAContent,
          AdditionalActions: withAcceptedContentActions(RxDFHendCAContentActions),
        }
      case legalAgreementIds.rxDFHendUSAug2021:
        return {
          Content: RxDFHendUSAug2021Content,
          AdditionalActions: withAcceptedContentActions(RxDFHendUSAug2021ContentActions),
        }
      case legalAgreementIds.rxDFHendUSJun2024:
        return {
          Content: RxDFHendUSContent,
          AdditionalActions: withAcceptedContentActions(RxDFHendUSContentActions),
        }
      case legalAgreementIds.rxDFHendUSMay2021:
        return {
          Content: RxDFHendUSMay2021Content,
          AdditionalActions: withAcceptedContentActions(RxDFHendUSMay2021ContentActions),
        }
      case legalAgreementIds.plOct022023:
        return {
          Content: PLAgreementOct022023Content,
          AdditionalActions: withAcceptedContentActions(PLAgreementOct022023ContentActions),
        }
      case legalAgreementIds.plOct052023:
        return {
          Content: PLAgreementContent,
          AdditionalActions: withAcceptedContentActions(PLAgreementContentActions),
        }
      case legalAgreementIds.baa:
        return {
          Content: BAAContent,
          AdditionalActions: null,
        }
      default:
        return defaultResponse
    }
  }, [agreementId])

  useEffect(() => {
    if (agreementId && Content) {
      modalDispatch({ type: 'open' })
    } else {
      modalDispatch({ type: 'close' })
    }
  }, [agreementId, Content, modalDispatch])

  return (
    <ClickWrapModal>
      <ClickWrapContextProvider accepted={true}>
        {Content && (
          <ClickWrapModalContent
            Content={Content}
            AdditionalActions={AdditionalActions}
            onAccept={() => {
              // empty callback since agreement is already accepted
            }}
            setUserInput={() => {
              // empty callback since agreement is already accepted
            }}
            acceptError={null}
          />
        )}
      </ClickWrapContextProvider>
    </ClickWrapModal>
  )
}

export default ViewAcceptedAgreement
